module.exports = __webpack_public_path__ + "img/Vector.74149071.svg";